import { render, staticRenderFns } from "./deleteCommunitySpacePerson.vue?vue&type=template&id=191495d6"
import script from "./deleteCommunitySpacePerson.vue?vue&type=script&lang=js"
export * from "./deleteCommunitySpacePerson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports